
import { Button } from "@/components/ui/button";
import { ArrowDownAZ, Clock, ThumbsUp } from "lucide-react";

type FeedbackSortOptionsProps = {
  sortOption: string;
  setSortOption: (option: string) => void;
};

const FeedbackSortOptions = ({ sortOption, setSortOption }: FeedbackSortOptionsProps) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant={sortOption === "most-voted" ? "default" : "outline"}
        size="sm"
        onClick={() => setSortOption("most-voted")}
        className="flex items-center gap-1"
      >
        <ThumbsUp className="h-4 w-4" />
        <span>Top</span>
      </Button>
      <Button
        variant={sortOption === "newest" ? "default" : "outline"}
        size="sm"
        onClick={() => setSortOption("newest")}
        className="flex items-center gap-1"
      >
        <Clock className="h-4 w-4" />
        <span>Newest</span>
      </Button>
    </div>
  );
};

export default FeedbackSortOptions;
